document.addEventListener('DOMContentLoaded', function () {

    BOLD.common.eventEmitter.on('BOLD_OPTIONS_option_products_loaded', function (event) {
        const compareAtPrice = document.querySelector('.product__price.product__price--compare');
        const actualPrice = document.querySelector('.bold_option_price_display');
        const difference = parseFloat(compareAtPrice.textContent.replace(/[^0-9.]+/g, "")) - parseFloat(actualPrice.textContent.replace(/[^0-9.]+/g, ""));


        function updateCompareAtPrice() {
            compareAtPrice.textContent = (parseFloat(actualPrice.textContent.replace(/[^0-9.]+/g, "")) + difference).toLocaleString(
                "en-US", { style: "currency", currency: "USD" });
        };

        if(compareAtPrice){
        console.log('Compare-at price.')
        document.querySelector('.bold_options_loaded').addEventListener('click', () => {
            setTimeout(updateCompareAtPrice, 500);
        })
        document.querySelector('.bold_options_loaded').addEventListener('change', () => {
            setTimeout(updateCompareAtPrice, 500);
        })} else {
            console.log('No compare-at price.');
        }
    })
})

